import { Box, Button, Modal, TextInput, toast } from '@palmetto/palmetto-components';
import { FormikValues, useFormik } from 'formik';
import { SyntheticEvent } from 'react';
import * as yup from 'yup';

import { adderMap, AdderType, ProgramType } from 'types';

import { useCreateConstructionAdderMutation } from '../../../services/pricing';

export const CreateMinCapacityAdderModal = ({
  isModalOpen,
  closeModal,
  adderType,
  programType,
}: {
  isModalOpen: boolean;
  closeModal: (event?: SyntheticEvent) => void;
  adderType?: string;
  programType: ProgramType;
}) => {
  const [createConstructionAdder] = useCreateConstructionAdderMutation();

  const formik = useFormik({
    initialValues: {
      name: '',
      minCapacity: undefined,
    },
    validationSchema: yup.object({
      name: yup.string().required('Option Name is required'),
      minCapacity: yup.number().required('Min capacity is required'),
    }),
    onSubmit: async (values: FormikValues, { setSubmitting, resetForm }) => {
      try {
        await createConstructionAdder({
          data: { adderType: adderType, name: values.name, minCapacity: parseInt(values.minCapacity) },
          programType,
        }).unwrap();
        toast.success('Adder created successfully');
        resetForm();
        closeModal();
      } catch (e) {
        console.error(e);
        toast.error('Error creating adder');
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <Modal ariaLabelledBy="createConstructionAdder" isOpen={isModalOpen} onDismiss={closeModal} maxWidth="500px">
      <Modal.Header
        id="createConstructionAdder"
        title={`Add ${adderMap[programType][adderType as AdderType]} Modifier`}
        onDismiss={closeModal}
      />
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body background="secondary">
          <Box direction="column" childGap="md">
            <TextInput
              type="text"
              label="Option Name"
              name="name"
              id="name"
              value={formik.values.name}
              onChange={(event) => formik.setFieldValue('name', event.target.value)}
              isRequired
              onBlur={formik.handleBlur}
              error={formik.touched.name && (formik.errors.name as string)}
            />
            <Box childGap="lg">
              <Box fontWeight="medium" color="body-primary">
                Modifiers
              </Box>
              <TextInput
                type="number"
                label="Minimum Capacity"
                name="minCapacity"
                id="minCapacity"
                value={formik.values.minCapacity}
                onChange={(event) => formik.setFieldValue('minCapacity', event.target.value)}
                isRequired
                onBlur={formik.handleBlur}
                error={formik.touched.minCapacity && (formik.errors.minCapacity as string)}
              />
            </Box>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as="button"
            onClick={() => {
              formik.resetForm();
              closeModal();
            }}
            variant="secondary"
            tone="neutral"
            size="md"
            isLoading={formik.isSubmitting}
          >
            Cancel
          </Button>
          <Button variant="primary" size="md" type="submit" isLoading={formik.isSubmitting}>
            Add Option
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
